import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=56417c83&scoped=true"
import script from "./BillingPlans.vue?vue&type=script&lang=js"
export * from "./BillingPlans.vue?vue&type=script&lang=js"
import style0 from "./BillingPlans.vue?vue&type=style&index=0&id=56417c83&prod&scoped=true&lang=scss"
import style1 from "./BillingPlans.vue?vue&type=style&index=1&id=56417c83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56417c83",
  null
  
)

export default component.exports